import React, {useCallback} from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import {MdClear, MdEmail, MdFileDownload} from "react-icons/md";
import {reportDownloadAllRequest, reportDownloadRequest, reportEmailAllRequest} from "../../api/Api";
import {ROUTES} from "../../utils/RouteConstants";
import {useHistory, useLocation} from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import {makeStyles} from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import {
    StatementActionsDiv,
    StatementSelectedListBodyDiv,
    StatementSelectedListHeaderDiv
} from "./StatementScreenStyles";
import {H5} from "../../styles/globalStyles";

const useStyles = makeStyles((theme) => ({
    list: {
        width: "100%",
        flexGrow:1,
        position: "relative",
        overflowX: "hidden",
        overflowY:"auto"
    },
}));

export default ({
    selectedMembers,
    setChecked,
    setFeedback,
    isSending,
    setIsSending,
    isMounted,
    close
}) => {

    const classes = useStyles();

    let history = useHistory();
    let location = useLocation();

    const downloadStatements = useCallback(
        async (selectedMembers) => {
            // don't send again while we are sending
            if (isSending) return;

            // update state
            setIsSending(true);
            // send the actual request

            async function getStatements() {
                var time = 3000;

                let resp;
                //console.log(selectedMembers);
                if (selectedMembers.length == 1) {
                    resp = await reportDownloadRequest(
                        "v1/reports/memberStatement/" + selectedMembers[0].id
                    );
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    let date = new Date();
                    let filename =
                        `${process.env.REACT_APP_ORG_NAME} ` +
                        selectedMembers[0].name +
                        " " +
                        selectedMembers[0].surname +
                        " " +
                        date.toDateString() +
                        ".pdf";
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                } else {
                    var list = Object.assign([], selectedMembers);

                    var list2 = Object.assign([], selectedMembers);

                    var time = 3000;

                    let req = "v1/reports/memberStatement/";

                    list.forEach(function (part, index) {
                        this[index] = req + part.id;
                    }, list);

                    resp = await reportDownloadAllRequest(list);

                    resp.data.forEach(function (part, index) {
                        console.log(part);
                        const url = window.URL.createObjectURL(new Blob([part.data], {type: 'application/pdf'}));
                        const link = document.createElement("a");
                        link.href = url;
                        let date = new Date();
                        let filename =
                            `${process.env.REACT_APP_ORG_NAME}: ` +
                            list2[index].name +
                            " " +
                            list2[index].surname +
                            " " +
                            date.toDateString() +
                            ".pdf";
                        link.setAttribute("download", filename);
                        document.body.appendChild(link);
                        link.click();
                    }, resp.data);
                }

                if (resp.message === "SUCCESS") {
                    setFeedback({
                        severity: "success",
                        message: "Success",
                        open: true,
                        time: time,
                        closeType: close,
                    });
                } else if (resp.message === "unauthorized") {
                    history.push(ROUTES.LOGIN, { last: location.pathname, data: location.state });
                } else if (resp.message === "no connection") {
                    time = 6000;
                    setFeedback({
                        severity: "error",
                        message: "Check your internet connection",
                        open: true,
                        time: time,
                        closeType: close,
                    });
                } else if (resp.message === "timeout") {
                    time = 6000;
                    setFeedback({
                        severity: "error",
                        message: "Request timed out. Please Try Again",
                        open: true,
                        time: time,
                        closeType: close,
                    });
                }
            }

            getStatements();

            // once the request is sent, update state again
            if (isMounted.current)
                // only update if we are still mounted
                setIsSending(false);
        },
        [isSending, location, history]
    ); // update the callback if the state changes

    const emailStatements = useCallback(
        async (selectedMembers) => {
            // don't send again while we are sending
            if (isSending) return;

            // update state
            setIsSending(true);
            // send the actual request

            async function getStatements() {
                var time = 3000;

                let resp;

                if (selectedMembers.length == 1) {
                    resp = await reportDownloadRequest(
                        "v1/reports/memberStatement/" +
                        selectedMembers[0].id +
                        "/" +
                        selectedMembers[0].email
                    );
                } else {
                    var list = Object.assign([], selectedMembers);

                    var time = 3000;

                    let req = "v1/reports/memberStatement/";

                    list.forEach(function (part, index) {
                        this[index] = req + part.id + "/" + part.email;
                    }, list);

                    resp = await reportEmailAllRequest(list);
                }

                if (resp.message === "SUCCESS") {
                    setFeedback({
                        severity: "success",
                        message: "Success",
                        open: true,
                        time: time,
                        closeType: close,
                    });
                } else if (resp.message === "unauthorized") {
                    history.push(ROUTES.LOGIN, { last: location.pathname, data: location.state });
                } else if (resp.message === "no connection") {
                    time = 6000;
                    setFeedback({
                        severity: "error",
                        message: "Check your internet connection",
                        open: true,
                        time: time,
                        closeType: close,
                    });
                } else if (resp.message === "timeout") {
                    time = 6000;
                    setFeedback({
                        severity: "error",
                        message: "Request timed out. Please Try Again",
                        open: true,
                        time: time,
                        closeType: close,
                    });
                }
            }

            getStatements();

            // once the request is sent, update state again
            if (isMounted.current)
                // only update if we are still mounted
                setIsSending(false);
        },
        [isSending, location, history]
    ); // update the callback if the state changes

    return (
        <>

            <StatementSelectedListHeaderDiv>
                <H5>Selected Members</H5>
                {selectedMembers.length >=1 &&
                    <StatementActionsDiv>
                    <Tooltip title="Clear Selection">
                        <IconButton
                            onClick={() => {
                                setChecked([]);
                            }}
                        >
                            <MdClear size={20} color="var(--menu-text)" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        title={
                            selectedMembers.length > 1
                                ? "Download Statements"
                                : "Download Statement"
                        }
                    >
                        <IconButton
                            onClick={() =>{if(selectedMembers.length>0)downloadStatements(selectedMembers) }}
                            disabled={isSending == true}
                        >
                            <MdFileDownload size={20} color="var(--menu-text)" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip
                        title={
                            selectedMembers.length > 1
                                ? "Email Statements"
                                : "Email Statement"
                        }
                    >
                        <IconButton
                            onClick={() => {if(selectedMembers.length>0)emailStatements(selectedMembers) }}
                            disabled={isSending == true}
                        >
                            <MdEmail size={20} color="var(--menu-text)" />
                        </IconButton>
                    </Tooltip>
                    </StatementActionsDiv>
                }
            </StatementSelectedListHeaderDiv>

            <StatementSelectedListBodyDiv>
                <List
                    className={classes.list}
                >
                    {selectedMembers.map((x) => {
                        return (
                            <ListItem
                                key={x.id}
                            >
                                <ListItemText
                                    id={x.id}
                                    primary= {x.name + " " + x.surname}
                                />
                            </ListItem>
                        )
                    })}

                </List>

            </StatementSelectedListBodyDiv>

        </>
    )
}